import React from 'react'
import FormField from '../Forms/FormField'
import GlassPanel from '../UI/GlassPanel'
import { calculateEventDuration } from '../../utils/durationUtils'

const BasicEventInfo = ({ event, onChange }) => {
  const eventTypes = [
    { value: 'festival', label: '🎪 Festival' },
    { value: 'concert', label: '🎵 Concert' },
    { value: 'streaming', label: '📺 Streaming Event' },
    { value: 'private', label: '🏠 Private Event' }
  ]

  const duration = calculateEventDuration(event.startDate, event.endDate, event.startTime, event.endTime)

  const privacyOptions = [
    { value: 'public', label: '🌍 Public - Visible to everyone' },
    { value: 'friends', label: '👥 Friends Only - Visible to friends' },
    { value: 'private', label: '🔒 Private - Only visible to you' }
  ]

  return (
    <GlassPanel className="p-6 mb-8">
      <h2 className="text-xl font-semibold text-white mb-6">📝 Basic Event Information</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <FormField
          label="Event Name"
          name="name"
          value={event.name}
          onChange={onChange}
          placeholder="Enter event name"
          required
        />

        <div>
          <label className="block text-sm font-medium text-gray-200 mb-2">Event Type</label>
          <select
            name="eventType"
            value={event.eventType}
            onChange={onChange}
            className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
          >
            {eventTypes.map((type) => (
              <option key={type.value} value={type.value} className="bg-gray-900">
                {type.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mb-6">
        <FormField
          label="Description"
          name="description"
          value={event.description}
          onChange={onChange}
          placeholder="Describe the event..."
          multiline
          rows={3}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <FormField
            type="date"
            label="Start Date"
            name="startDate"
            value={event.startDate}
            onChange={onChange}
            required
            disabled={event.dateTBA}
          />
          {event.dateTBA && (
            <div className="mt-1 text-yellow-400 text-sm font-medium">
              Date TBA
            </div>
          )}
        </div>

        <div>
          <FormField
            type="date"
            label="End Date"
            name="endDate"
            value={event.endDate}
            onChange={onChange}
            required
            disabled={event.dateTBA}
          />
          {event.dateTBA && (
            <div className="mt-1 text-yellow-400 text-sm font-medium">
              Date TBA
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <FormField
            type="time"
            label="Start Time"
            name="startTime"
            value={event.startTime}
            onChange={onChange}
            placeholder="Event start time"
            disabled={event.timeTBA || event.noSpecificTime}
          />
          {(event.timeTBA || event.noSpecificTime) && (
            <div className="mt-1 text-yellow-400 text-sm font-medium">
              {event.timeTBA ? "Time TBA" : "No Specific Time"}
            </div>
          )}
        </div>

        <div>
          <FormField
            type="time"
            label="End Time"
            name="endTime"
            value={event.endTime}
            onChange={onChange}
            placeholder="Event end time"
            disabled={event.endTimeTBA || event.noSpecificTime}
          />
          {(event.endTimeTBA || event.noSpecificTime) && (
            <div className="mt-1 text-yellow-400 text-sm font-medium">
              {event.endTimeTBA ? "End Time TBA" : "No Specific Time"}
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <FormField
          label="Timezone"
          name="timezone"
          value={event.timezone}
          onChange={onChange}
          placeholder="e.g., America/New_York, UTC"
        />

        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="spanMultipleDays"
              name="spanMultipleDays"
              checked={event.spanMultipleDays}
              onChange={onChange}
              className="w-5 h-5 text-purple-600 bg-white/10 border-white/20 rounded focus:ring-purple-500"
            />
            <label htmlFor="spanMultipleDays" className="text-white font-medium">
              Multi-day Event
            </label>
          </div>

          {duration && (
            <div className="bg-blue-500/20 border border-blue-500/30 rounded-lg p-3">
              <span className="text-blue-300 text-sm font-medium">
                Duration: {duration}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <FormField
          label="Venue Name"
          name="venueName"
          value={event.venueName}
          onChange={onChange}
          placeholder="Enter venue name"
          required
        />

        <FormField
          label="Country"
          name="country"
          value={event.country}
          onChange={onChange}
          placeholder="Enter country"
          required
        />
      </div>


      <div>
        <label className="block text-sm font-medium text-gray-200 mb-2">Privacy Setting</label>
        <select
          name="privacy"
          value={event.privacy}
          onChange={onChange}
          className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
        >
          {privacyOptions.map((option) => (
            <option key={option.value} value={option.value} className="bg-gray-900">
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </GlassPanel>
  )
}

export default BasicEventInfo